package com.sweetlime.bingeamigo

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

object AppLifecycle {
    private val _isForegrounded = MutableStateFlow(true)
    val isForegrounded: StateFlow<Boolean> = _isForegrounded.asStateFlow()

    fun onBackground() {
        _isForegrounded.value = false
    }

    fun onForeground() {
        _isForegrounded.value = true
    }
}
